import { render, staticRenderFns } from "./DuplicatesTab.vue?vue&type=template&id=f1bda85e&"
import script from "./DuplicatesTab.vue?vue&type=script&lang=js&"
export * from "./DuplicatesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports